// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3FAW8","title":"AfterFrontImage_title__m-TY_"};